import React from 'react';
import { CFormInput } from '@coreui/react';

const DateInput = ({ label, name, value, onChange, className }) => {
   // Function to ensure the date is in "YYYY-MM-DD" format
   const formatDate = (date) => {
      if (!date) return ''; // Return an empty string for null/undefined
      const parsedDate = new Date(date);
      return isNaN(parsedDate) ? '' : parsedDate.toISOString().split('T')[0]; // Ensure valid date
   };

   const handleChange = (e) => {
      const formattedDate = formatDate(e.target.value);
      if (onChange) {
         onChange({ target: { name, value: formattedDate } });
      }
   };

   return (
      <CFormInput
         type="date"
         label={label}
         name={name}
         value={formatDate(value)} // Always format before rendering
         onChange={handleChange}
         className={className || "mb-3"}
         onClick={(e) => {
            if (e.target.showPicker) {
               e.target.showPicker(); // Open date picker when clicking the field
            }
         }}
      />
   );
};

export default DateInput;
